import React from 'react';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';

const Wrapper = Flex.extend`
  width: 90%;
  margin: 100px auto 0;
  padding: 0 74px 100px;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  transition: all .5s;

  ${media.tablet`
    padding: 0;
  `}
  ${media.w800`
    flex-direction: column;
    margin-top: 30px;
  `}
  ${media.mobile`
    width: 100%;
  `}
`;

const Left = styled.div`
  width: 50%;

  ${media.tablet`
    width: 60%;
  `}
  ${media.w800`
    width: 90%;
    margin: 0 auto;
  `}
`;

const Right = styled.div`
  width: 320px;
  margin-left: 104px;

  ${media.tablet`
    margin: 30px 50px;
  `}
  ${media.mobile`
    margin: 40px 40px 70px;
  `}
`;

const Img = styled.img`
  width: 100%;
`;

const Title = styled.p`
  margin: 10px 0 60px;
  height: 19px;
  font-family: Lato;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1.2px;
  text-align: left;
  color: #343434;

  ${media.mobile`
    font-size: 18px;
    letter-spacing: 0.9px;
    margin: 0 0 42px;
  `}
`;

const Eng = styled.p`
  width: 100%;
  margin-top: 46px;
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.8px;
  text-align: left;
  color: #999999;

  ${media.mobile`
    font-size: 14px;
    letter-spacing: 0.7px;
    margin-top: 32px;
  `}
`;

const Desc = styled.p`
  margin-top: 15px;
  width: 100%;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 18px;
  letter-spacing: 0.9px;
  text-align: left;
  color: #444444;

  ${media.mobile`
    font-size: 14px;
    letter-spacing: 0.7px;
    margin-top: 13px;
  `}
`;

const Showroom = () => (
  <Wrapper>
    <Left>
      <Img src="/images/contact/showroom.jpg" />
    </Left>
    <Right>
      <Title>SHOWROOM BANGBAE</Title>
      <Eng>LOCATION</Eng>
      <Desc>서울 서초구 방배로 42길 50-2 1층</Desc>
      <Eng>TEL</Eng>
      <Desc>02.536.6148</Desc>
      <Eng>OPENING HOURS</Eng>
      <Desc>화-토 : 오전 11:00 – 오후 6:00</Desc>
      <Desc>일/월/공휴일- 휴무</Desc>
    </Right>
  </Wrapper>
);

export default Showroom;



// WEBPACK FOOTER //
// ./src/components/Contact/Showroom.js